import React from "react";
import { Star } from "@mui/icons-material";
import { ListItemIcon, MenuItem, Typography } from "@mui/material";

import { ResourceEntity } from "fond/types";

import { useStarred } from "./hooks/useStarred";
import { CommonItemMenuProps } from "./types";

interface IProps extends Pick<CommonItemMenuProps, "onMenuClose" | "source"> {
  resource: ResourceEntity;
}

const StarMenuItem: React.FC<IProps> = ({ onMenuClose, resource, source }) => {
  const { starred, addToStarred, removeFromStarred } = useStarred();
  const isStarred = starred.includes(resource.ID);
  const label = !isStarred ? "Add to Starred" : "Remove from Starred";

  return (
    <MenuItem
      aria-label={label}
      onClick={(event: React.MouseEvent) => {
        if (isStarred) {
          removeFromStarred(resource, source);
        } else {
          addToStarred(resource, source);
        }
        onMenuClose(event);
      }}
      data-testid="starred-button"
    >
      <ListItemIcon>
        <Star />
      </ListItemIcon>
      <Typography variant="inherit">{label}</Typography>
    </MenuItem>
  );
};

export default StarMenuItem;
